import { styled } from "styled-components";

export const HeaderWrapper = styled.div`
	padding: 20px 0;
`;

export const CardWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 12px 0 36px;

	.chartCard,
	& > div {
		width: 48%;
		padding-left: 20px;
		padding-right: 20px;
	}
`;

export const FileUploadWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 8px;
	height: 41px;
	border-radius: 6px;
	border: 1px solid #b8c8cf;
	gap: 0.75rem;

	a,
	p {
		font-size: 14px;
		font-weight: 700;
		color: #003a50;
	}

	> button {
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px solid #b8c8cf;
		height: 30px;
		min-width: 35px;
		border-radius: 5px;
	}
`;
